export function getAutomationTemplateSaveButtonLabel(input: {
  isUpdatePending: boolean;
  jobSyncActive: boolean;
  syncingTenantCount: number;
  isSyncMutationPending: boolean;
}): string {
  const { isUpdatePending, jobSyncActive, syncingTenantCount, isSyncMutationPending } = input;
  if (isUpdatePending) {
    return 'Saving...';
  }
  if (jobSyncActive) {
    return syncingTenantCount === 0 ? 'Starting Sync...' : `Syncing (${syncingTenantCount})...`;
  }
  if (isSyncMutationPending) {
    return 'Syncing...';
  }
  return 'Save';
}
